import { render } from "./Healthcare.vue?vue&type=template&id=0ad6b525&scoped=true"
import script from "./Healthcare.vue?vue&type=script&lang=js"
export * from "./Healthcare.vue?vue&type=script&lang=js"

import "./Healthcare.vue?vue&type=style&index=0&id=0ad6b525&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ad6b525"]])

export default __exports__